'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@tiptap/core');

/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */
const Text = core.Node.create({
    name: 'text',
    group: 'inline',
});

exports.Text = Text;
exports.default = Text;
//# sourceMappingURL=index.cjs.map
